






































































































































































































































































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import Requester from '../../requester';

import {
  estadoCivilItems,
  escolaridadeItems,
  tipoTelefoneIcons,
  tipoTelefoneItems,
  tipoTelefoneStrings,
} from '../../utils/constants';
import { Paciente } from '../../../../back/src/entity/Paciente';

import Carregando from '../Carregando.vue';
import Confirmar from '../Confirmar.vue';
import { PacientePostFormData, PacientePutFormData } from '../../../../back/src/types';
import { dataBrToDate } from '../../utils/functions';

export default Vue.extend({
  name: 'ThePacientesCadastroInternoDadosPessoais',
  components: {
    Carregando,
    Confirmar,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
      default: null,
    },
  },
  data() {
    return {
      loading: {
        form: false,
        cpf: false,
        email: false,
        submit: false,
      },
      valid: false,
      lastCpfError: '',
      form: {
        nome: '',
        cpf: '',
        rg: '',
        dataNascimento: '',
        email: '',
        tipoTelefone1: '',
        telefone1: '',
        tipoTelefone2: '',
        telefone2: '',
        profissao: '',
        escolaridade: '',
        estadoCivil: '',
        estadoCivilOutro: '',
        parceiroNome: '',
        parceiroTipoTelefone: '',
        parceiroTelefone: '',
        parceiroProfissao: '',
        parceiroEscolaridade: '',
      },
      errorMessages: {
        cpf: [] as string[],
        email: [] as string[],
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
        cpf: [
          (v: string) => !!v || 'Campo obrigatório',
          (v: string) => (v && v.length === 14) || 'CPF incompleto',
          (v: string) => {
            const cpf: string = v.replace(/\D+/gm, '');
            if (cpf.length !== 11) {
              return 'CPF inválido';
            }
            let soma: number;
            let resto: number;
            if (Number(cpf) % 11111111111 === 0) {
              return 'CPF inválido';
            }
            soma = 0;
            for (let i = 1; i <= 9; i += 1) {
              soma += Number(cpf.substring(i - 1, i)) * (11 - i);
            }
            resto = (soma * 10) % 11;
            if ((resto === 10) || (resto === 11)) {
              resto = 0;
            }
            if (resto !== Number(cpf.substring(9, 10))) {
              return 'CPF inválido';
            }
            soma = 0;
            for (let i = 1; i <= 10; i += 1) {
              soma += Number(cpf.substring(i - 1, i)) * (12 - i);
            }
            resto = (soma * 10) % 11;
            if ((resto === 10) || (resto === 11)) {
              resto = 0;
            }
            if (resto !== Number(cpf.substring(10, 11))) {
              return 'CPF inválido';
            }
            return true;
          },
        ],
        email: [
          (v: string) => !!v || 'Campo obrigatório',
          (v: string) => {
            const emailPattern: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return (v && emailPattern.test(v)) || 'E-mail inválido';
          },
        ],
        date: [
          (v: string) => !!v || 'Campo obrigatório',
          (v: string) => {
            if (!v) return true;
            const date = v.split('/').reverse().join('-');
            const momentDate = moment(date);
            return (v && momentDate.isValid() && momentDate.isAfter('1900-01-01'))
              || 'Data inválida';
          },
        ],
      },
      items: {
        tipoTelefone: tipoTelefoneItems,
        estadoCivil: estadoCivilItems,
        escolaridade: escolaridadeItems,
      },
    };
  },
  computed: {
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    classActions(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex justify-space-between pt-0 pb-2';
      }
      return 'd-flex justify-end pt-0 pb-2';
    },
    formDadosPessoais(): Vue & { validate: () => boolean, resetValidation: () => boolean } {
      return this.$refs.formDadosPessoais as Vue & {
        validate: () => boolean,
        resetValidation: () => boolean
      };
    },
  },
  methods: {
    preencheForm() {
      this.loading.form = true;
      if (!_.isEmpty(this.paciente)) {
        this.form.nome = this.paciente.nome;
        this.form.cpf = this.paciente.cpf;
        this.form.rg = this.paciente.rg;
        if (this.paciente.data_nascimento) {
          const momentDataNascimento = moment(this.paciente.data_nascimento);
          this.form.dataNascimento = momentDataNascimento.isValid()
            ? momentDataNascimento.utc().format('DD/MM/YYYY')
            : '';
        } else {
          this.form.dataNascimento = '';
        }
        this.form.email = this.paciente.email;
        this.form.telefone1 = this.paciente.telefone1;
        this.form.tipoTelefone1 = this.paciente.tipo_telefone1 || '';
        this.form.telefone2 = this.paciente.telefone2;
        this.form.tipoTelefone2 = this.paciente.tipo_telefone2 || '';
        this.form.profissao = this.paciente.profissao;
        this.form.escolaridade = this.paciente.escolaridade;
        this.form.estadoCivil = this.paciente.estado_civil;
        this.form.estadoCivilOutro = this.paciente.estado_civil_outro;
        this.form.comoConheceu = this.paciente.como_conheceu;
        this.form.parceiroNome = this.paciente.parceiro_nome;
        this.form.parceiroTipoTelefone = this.paciente.parceiro_tipo_telefone || '';
        this.form.parceiroTelefone = this.paciente.parceiro_telefone || '';
        this.form.parceiroProfissao = this.paciente.parceiro_profissao;
        this.form.parceiroEscolaridade = this.paciente.parceiro_escolaridade;
      }
      this.loading.form = false;
    },
    // eslint-disable-next-line func-names
    validaEmailDebounce: _.debounce(async function () { await this.validaEmail(); }, 200),
    async validaEmail() {
      this.loading.email = true;
      // Nova paciente
      if (this.paciente == null && this.form.email.length === 0) {
        this.errorMessages.email = [] as string[];
        this.loading.email = false;
        return;
      }
      // Editando paciente
      if (this.paciente && (this.form.email.length === 0
          || this.form.email.localeCompare(this.paciente.email) === 0)) {
        this.errorMessages.email = [] as string[];
        this.loading.email = false;
        return;
      }
      try {
        const response = await Requester.paciente.validaEmail(this.form.email);
        if (response.errors.length > 0) {
          this.errorMessages.email = response.errors;
        } else {
          this.errorMessages.email = [] as string[];
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.email = false;
      }
    },
    // eslint-disable-next-line func-names
    validaCpfDebounce: _.debounce(async function () { await this.validaCpf(); }, 200),
    async validaCpf() {
      if (this.form.cpf.length < 14) {
        return;
      }
      this.loading.cpf = true;
      if (this.form.cpf === this.lastCpfError) {
        this.loading.cpf = false;
        return;
      }
      try {
        const response = await Requester.paciente.validaCpf(this.form.cpf);
        if (response.errors.length > 0) {
          this.lastCpfError = this.form.cpf;
          this.errorMessages.cpf = response.errors;
        } else {
          this.errorMessages.cpf = [] as string[];
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.cpf = false;
      }
    },
    maskTelefone(telefone: string) : string {
      if (telefone.length > 14) {
        return '(##) #####-####';
      }
      return '(##) ####-#####';
    },
    iconTelefone(tipoTelefone: string) : string {
      if (_.has(tipoTelefoneIcons, tipoTelefone)) {
        return tipoTelefoneIcons[tipoTelefone];
      }
      return '';
    },
    placeholderTelefone(tipoTelefone: string): string {
      if (_.has(tipoTelefoneStrings, tipoTelefone)) {
        return tipoTelefoneStrings[tipoTelefone];
      }
      return '';
    },
    // eslint-disable-next-line func-names
    desfazerDebounce: _.debounce(async function () { await this.desfazer(); }, 200),
    async desfazer() {
      if (await this.confirmar.open(
        'Desfazer edição',
        'Tem certeza que deseja desfazer a edição?\nOs dados alterados serão perdidos.',
      ) === false) {
        return;
      }
      this.$emit('desfazer');
      this.formDadosPessoais.resetValidation();
    },
    // eslint-disable-next-line func-names
    submitFormEditDebounce: _.debounce(async function () { await this.submitFormEdit(); }, 200),
    async submitFormEdit() {
      this.loading.submit = true;
      if (!this.formDadosPessoais.validate()) {
        this.loading.submit = false;
        return;
      }
      const formData: PacientePutFormData = {
        id: this.paciente.id,
        nome: this.form.nome,
        cpf: this.form.cpf,
        rg: this.form.rg,
        data_nascimento: dataBrToDate(this.form.dataNascimento),
        email: this.form.email,
        tipo_telefone1: this.form.tipoTelefone1,
        telefone1: this.form.telefone1,
        tipo_telefone2: this.form.tipoTelefone2,
        telefone2: this.form.telefone2,
        profissao: this.form.profissao,
        escolaridade: this.form.escolaridade,
        estado_civil: this.form.estadoCivil,
        estado_civil_outro: this.form.estadoCivilOutro,
        como_conheceu: this.form.comoConheceu,
        parceiro_nome: this.form.parceiroNome,
        parceiro_tipo_telefone: this.form.parceiroTipoTelefone,
        parceiro_telefone: this.form.parceiroTelefone,
        parceiro_profissao: this.form.parceiroProfissao,
        parceiro_escolaridade: this.form.parceiroEscolaridade,
      };
      try {
        const response = await Requester.paciente.alteraPaciente(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$emit('atualizaPaciente', response.data);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Paciente atualizada com sucesso!' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
    // eslint-disable-next-line func-names
    cancelarDebounce: _.debounce(function () { this.cancelar(); }, 200),
    cancelar() {
      this.$emit('cancelar');
      this.formDadosPessoais.resetValidation();
      this.preencheForm();
    },
    // eslint-disable-next-line func-names
    submitFormNovaDebounce: _.debounce(async function () { await this.submitFormNova(); }, 200),
    async submitFormNova() {
      this.loading.submit = true;
      if (!this.formDadosPessoais.validate()) {
        this.loading.submit = false;
        return;
      }
      const formData: PacientePostFormData = {
        nome: this.form.nome,
        cpf: this.form.cpf,
        rg: this.form.rg,
        data_nascimento: dataBrToDate(this.form.dataNascimento),
        email: this.form.email,
        tipo_telefone1: this.form.tipoTelefone1,
        telefone1: this.form.telefone1,
        tipo_telefone2: this.form.tipoTelefone2,
        telefone2: this.form.telefone2,
        profissao: this.form.profissao,
        escolaridade: this.form.escolaridade,
        estado_civil: this.form.estadoCivil,
        estado_civil_outro: this.form.estadoCivilOutro,
        como_conheceu: this.form.comoConheceu,
        parceiro_nome: this.form.parceiroNome,
        parceiro_tipo_telefone: this.form.parceiroTipoTelefone,
        parceiro_telefone: this.form.parceiroTelefone,
        parceiro_profissao: this.form.parceiroProfissao,
        parceiro_escolaridade: this.form.parceiroEscolaridade,
      };
      try {
        const response = await Requester.paciente.criaPaciente(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$router.push({ name: 'PacientesVer', params: { pacienteId: response.data.id } });
          this.$emit('novaPaciente', response.data);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Paciente cadastrada com sucesso!' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
  },
});
